import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/AddTaskDependencyWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import AddDependencyIcon from '../assets/images/link-new-16x16.svg';
import { withRouter } from 'react-router';
import {
  addTaskDependencies,
  readTask,
} from '../redux/actions/table/all_tasks';
import { setNotification } from '../redux/actions/general/notification';
import AddTaskDependencyForm from '../forms/add_task_dependency_wizard/AddTaskDependencyForm';
import * as _ from 'lodash';

@mapStateToProps((state) => ({
  store: _.get(state.table, 'all_tasks'),
}))
@withRouter
class AddTaskDependencyWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    const wizard = this.props.store.add_task_dependency_wizard;

    return validateForm(
      addTaskDependencies(wizard.task_id, {
        ...formData,
        direction: wizard.direction,
      }).then(() =>
        readTask(wizard.task_id).then(() => {
          if (this.props.match.path == '/meetings/:meeting') {
            setTableParams('all_tasks', {
              clicked_row: wizard.task_id,
            });
          }

          setNotification(
            wizard.direction === 'predecessor'
              ? __(
                  'task.dependencies.predecessor-added',
                  {},
                  'Predecessor added'
                )
              : __('task.dependencies.successor-added')
          );

          this.props.onClose();
        })
      )
    );
  }

  render() {
    const direction = this.props.store.add_task_dependency_wizard?.direction;
    const isPredecessor = direction === 'predecessor';

    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>
              {isPredecessor
                ? __('button.add-predecessor')
                : __('button.add-successor')}
            </span>
            <span>
              {isPredecessor
                ? __('task.dependencies.add-predecessor-description')
                : __('task.dependencies.add-successor-description')}
            </span>
          </div>
          <div className={styles.right}>
            <AddDependencyIcon />
          </div>
        </div>
        <div className={styles.body}>
          <AddTaskDependencyForm
            onSubmit={this._handleSubmit}
            initialValues={{
              task_ids: [],
            }}
          />
        </div>
      </>
    );
  }
}

export default AddTaskDependencyWizard;
